export function userSeatLimitErrorMessage(payload, t) {
  const code = payload?.error_code;
  if (code === 'user_seat_downgrade_blocked') {
    return t('subscriptionChanges:seatDowngradeBlocked', {
      occupied: payload.occupied_login_seats,
      max: payload.max_users,
    });
  }
  if (code === 'user_seat_count_unavailable') {
    return t('subscriptionChanges:seatCountUnavailable');
  }
  return null;
}
